import {
  AFFINITY,
  ANSWER,
  SURA,
  SURA_EMPLOYEES,
} from '../../constants/website.constant';
import { PUBLIC_HTTP as http } from '../http-common';

const nextLogin = (value) => {
  localStorage.setItem('user', JSON.stringify(value));
};

const login = async (identification_number: string, password: string) => {
  return http
    .post('/api/v4/sessions', {
      identification_number,
      password,
    })
    .then((response) => {
      if (response.data.access_token) {
        if (process.env.REACT_APP_WEBSITE === SURA) {
          if (
            response.data?.user?.company.toUpperCase() === SURA ||
            response.data?.user?.company === AFFINITY
          ) {
            localStorage.setItem('user', JSON.stringify(response.data));
          } else {
            throw new EvalError('not_company');
          }
        }

        if (process.env.REACT_APP_WEBSITE === ANSWER) {
          if (
            response.data?.user?.company.toUpperCase() === ANSWER ||
            response.data?.user?.company === SURA_EMPLOYEES
          ) {
            localStorage.setItem('user', JSON.stringify(response.data));
          } else {
            throw new EvalError('not_company');
          }
        }
      }

      if (response.data.error_code === 406) {
        throw new EvalError('affinity_user');
      }

      if (
        process.env.REACT_APP_WEBSITE === ANSWER &&
        response.data.error === 'Invalid authentication credentials'
      ) {
        throw new EvalError('invalid_auth_answer');
      }

      return response;
    });
};

const logout = () => {
  localStorage.removeItem('user');
  sessionStorage.removeItem('user');
};

const getUserAuthData = () => {
  return JSON.parse(localStorage.getItem('user') || '{}');
};

export { nextLogin, login, logout, getUserAuthData };
